// src/components/ContactPage.js
import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';
import './ContactPage.css';

const ContactPage = () => {
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');

  const form = useRef();
  const recaptchaRef = useRef();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  // ページ表示時にトップへスクロール
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const token = recaptchaRef.current.getValue();

    if (!token) {
      setSubmitMessage(isEnglish ? "Please complete the reCAPTCHA." : "reCAPTCHA認証を完了してください。");
      setIsSubmitting(false);
      return;
    }

    const templateParams = {
      user_name: form.current.user_name.value,
      user_email: form.current.user_email.value,
      subject: form.current.subject.value,
      message: form.current.message.value,
      'g-recaptcha-response': token,
    };

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID,
      templateParams,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
      .then((result) => {
        setSubmitMessage(isEnglish ? 'Your inquiry has been sent. Thank you.' : 'お問い合わせありがとうございます。送信が完了しました。');
        form.current.reset();
        recaptchaRef.current.reset();
      }, (error) => {
        setSubmitMessage(isEnglish ? 'Failed to send message. Please try again later.' : 'メッセージの送信に失敗しました。時間をおいて再度お試しください。');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const content = isEnglish ? {
    title: 'Contact Us',
    subtitle: 'We are here to help you.',
    description: 'For inquiries about our facility, reservations, or anything else, please feel free to contact us.',
    name: 'Name',
    email: 'Email',
    subject: 'Subject',
    message: 'Message',
    submit: 'Send Message'
  } : {
    title: 'お問い合わせ',
    subtitle: 'Contact',
    description: '施設やご予約に関するご質問、その他のお問い合わせは、以下のフォームよりお気軽にご連絡ください。',
    name: 'お名前',
    email: 'メールアドレス',
    subject: '件名',
    message: 'お問い合わせ内容',
    submit: '送信する'
  };

  return (
    <div className="contact-page-wrapper">
      <div className="contact-page-container">
        <div className="contact-header">
          <span className="contact-subtitle">{content.subtitle}</span>
          <h1>{content.title}</h1>
          <div className="title-divider"></div>
          <p className="contact-description">{content.description}</p>
        </div>

        <form ref={form} onSubmit={sendEmail} className="contact-form-luxury">
          <div className="form-group-line">
            <label>{content.name} <span className="required">*</span></label>
            <input type="text" name="user_name" required placeholder={isEnglish ? "Your Name" : "山田 太郎"} />
          </div>

          <div className="form-group-line">
            <label>{content.email} <span className="required">*</span></label>
            <input type="email" name="user_email" required placeholder={isEnglish ? "email@example.com" : "email@example.com"} />
          </div>

          <div className="form-group-line">
            <label>{content.subject} <span className="required">*</span></label>
            <input type="text" name="subject" required />
          </div>

          <div className="form-group-area">
            <label>{content.message} <span className="required">*</span></label>
            <textarea name="message" rows="6" required></textarea>
          </div>

          <div className="recaptcha-container">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              hl={isEnglish ? 'en' : 'ja'}
            />
          </div>

          <button type="submit" className="btn-submit-luxury" disabled={isSubmitting}>
            {isSubmitting ? (isEnglish ? 'Sending...' : '送信中...') : content.submit}
          </button>
        </form>

        {submitMessage && (
          <div className={`submit-message-box ${submitMessage.includes('failed') || submitMessage.includes('失敗') ? 'error' : 'success'}`}>
            {submitMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactPage;